import useIconColor from '../../hooks/useIconColor';

const Apple = () => {
  const { background } = useIconColor();

  return (
    <svg width='24' height='24' viewBox='0 0 31 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M23.2154 16.3638C23.2404 14.2641 24.402 12.3195 26.2756 11.21C25.089 9.58753 23.1654 8.59733 21.092 8.53768C18.9062 8.32293 16.7953 9.77841 15.6837 9.77841C14.572 9.77841 12.8359 8.54961 10.9998 8.5854C8.57664 8.65698 6.36583 9.94543 5.19173 11.9735C2.68116 16.1252 4.55472 22.2334 6.96537 25.5858C8.16445 27.2322 9.57587 29.0694 11.412 28.9978C13.2106 28.9262 13.8851 27.9003 16.0584 27.9003C18.2317 27.9003 18.8438 28.9978 20.7173 28.962C22.6533 28.9262 23.8649 27.3157 25.0265 25.6455C25.8884 24.4763 26.5628 23.1759 27 21.804C24.7018 20.8734 23.2154 18.726 23.2029 16.3519L23.2154 16.3638Z'
        fill={background}
      />
      <path
        d='M19.6679 6.33057C20.7171 5.12563 21.2417 3.56278 21.1168 1.99994C19.5055 2.16696 18.0191 2.8947 16.945 4.06385C15.8958 5.20914 15.3587 6.71233 15.4586 8.23939C17.0948 8.25132 18.6437 7.55937 19.6679 6.3425V6.33057Z'
        fill={background}
      />
    </svg>
  );
};

export default Apple;
